/**
 * Constants for file download utilities
 */
export const DOWNLOAD_CONFIG = {
  FILE_PATH_PREFIX: "file/",
  DOWNLOAD_FILE_RECORDING_PATH: "file/downloadFileRecording/",
  DEFAULT_MIME_TYPE: "application/octet-stream",
  CLEANUP_DELAY_MS: 100,
  RESPONSE_TYPE: "blob" as const,
} as const;
